import {
	Integration,
	IntegrationFeatureWebhook,
	IntegrationProviderId,
	IntegrationStatus,
	SettingsConfig,
	SettingsConfigType,
} from "../../../../index";

const plutioIntegration = new Integration({
	id: "plutio",
	name: "Plutio integration",
	description:
		"Plutio is a cloud-based business management software that helps you manage your business from anywhere. It is a complete business management solution that includes CRM, project management, invoicing, time tracking,expense management, and more.",
	providerId: IntegrationProviderId.PLUTIO,
	status: IntegrationStatus.ACTIVE,
	docsUrl: "https://docs.version2.io/7hY9grRLhaxMZqwjG",
	features: [new IntegrationFeatureWebhook()],
	settingsConfig: [
    new SettingsConfig({
      id: "embedded_custom_css",
      label: "Embedded screens custom CSS",
      description: "Style Version2 screens inside Plutio. Use :root for theme variables (for example --primary: #3d0ebf), or target .v2-github-sync__agent-card and .v2-plutio-credits__card. Leave empty to restore Plutio's theme. Remote assets, imports and global at-rules are not supported. Reload Plutio after saving.",
      type: SettingsConfigType.STRING,
      required: false,
      editable: true,
      encrypted: false,
      data: { multiline: true, maxLength: 20_000, rows: 6 },
    }),
		new SettingsConfig({
			id: "display_name",
			label: "Integration name",
			description:
				"The name of the integration that will be displayed in the integrations list",
			type: SettingsConfigType.STRING,
			required: true,
			editable: true,
			encrypted: false,
		}),
		new SettingsConfig({
			id: "client_id",
			label: "Client ID",
			description: "The Client ID of your Plutio app",
			type: SettingsConfigType.STRING,
			required: true,
			editable: true,
			encrypted: false,
		}),
		new SettingsConfig({
			id: "client_secret",
			label: "Client Secret",
			description: "The Client Secret of your Plutio app",
			type: SettingsConfigType.STRING,
			required: true,
			editable: true,
			encrypted: true,
		}),
		new SettingsConfig({
			id: "subdomain",
			label: "Workspace subdomain",
			description:
				"The first part of your Plutio workspace domain. For example, use 'acme' for acme.plutio.com.",
			type: SettingsConfigType.STRING,
			required: true,
			editable: true,
			encrypted: false,
		}),
		new SettingsConfig({
			id: "plutio_auth_custom_field_id",
			label: "Passwordless authentication custom field ID",
			description:
				"The Plutio person custom field used for short-lived Version2 authentication challenges.",
			type: SettingsConfigType.STRING,
			required: false,
			editable: true,
			encrypted: false,
		}),
		new SettingsConfig({
			id: "webhook_url",
			label: "Webhook URL",
			description: "The Webhook URL for your Plutio app",
			type: SettingsConfigType.KEY,
			required: true,
			editable: false,
			encrypted: false,
		}),
	],
});

export default plutioIntegration;
